import styled from '@emotion/styled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SvgIcon = styled.svg(props => ({
  minWidth: `${props.width}px`,
  minHeight: `${props.height}px`
}));